import { DiscoveryFilter, FilterTypes } from '../../data/filters/discovery.data';
import { Step } from 'react-joyride';
import { CreatorLocation, IAudition, IContest, IEvent } from '../../types/global/helper';
import { TextFieldProps } from '@mui/material';
import { ICustomizedMultipleInput } from '../../components/CustomizedMultipleInput/CustomizedMultipleInput';
import { IRegistrationForm } from '../../types/global/forms.types';
import { IRole } from '../../types/global/AuditionDetailsEditor.types';

export const types = {
    SET_PAGE: 'SET_PAGE',
    SET_APP_LOADING: 'SET_APP_LOADING',
    TOGGLE_APP_DRAWER: 'TOGGLE_APP_DRAWER',
    SET_FILTER: 'SET_FILTER',
    SET_FILTER_SUB_CATEGORY: 'SET_FILTER_SUB_CATEGORY',
    CHANGE_FILTER_SELECTION: 'CHANGE_FILTER_SELECTION',
    SET_FILTER_SUB_SELECTION: 'SET_FILTER_SUB_SELECTION',
    CLEAR_FILTER: 'CLEAR_FILTER',
    TOGGLE_FILTER: 'TOGGLE_FILTER',
    TOGGLE_NOTIFICATION: 'TOGGLE_NOTIFICATION',
    TOGGLE_ACCOUNT_MODAL: 'TOGGLE_ACCOUNT_MODAL',
    TOGGLE_CREATOR_MODAL: 'TOGGLE_CREATOR_MODAL',
    TOGGLE_COOKIES_DRAWER: 'TOGGLE_COOKIES_DRAWER',
    TOGGLE_TOAST: 'TOGGLE_TOAST',

    SET_SHOW_GUIDE: 'SET_SHOW_GUIDE',

    SET_GUIDE_LINK: 'SET_GUIDE_LINK',

    SET_SHOW_SEARCH_BOX: 'SET_SHOW_SEARCH_BOX',

    SET_SHOW_PROJECT_CREATOR_GUIDE: 'SET_SHOW_PROJECT_CREATOR_GUIDE',

    SET_SHOW_PROJECT_SUGGESTION_BOX: 'SET_SHOW_PROJECT_SUGGESTION_BOX',

    SET_SHARE_MODAL_STATUS: 'SET_SHARE_MODAL_STATUS',

    RESET_REDIRECT: 'RESET_REDIRECT',

    /** Set Whether the project guide is shown */
    SET_PROJECT_GUIDE: 'SET_PROJECT_GUIDE',

    /** Get the value of the project guide */
    GET_PROJECT_GUIDE: 'GET_PROJECT_GUIDE',

    TOGGLE_THEME: 'TOGGLE_THEME',

    GET_FILTERS: 'GET_FILTERS',
    GET_FILTERS_SUCCESS: 'GET_FILTERS_SUCCESS',
    GET_FILTERS_FAIL: 'GET_FILTERS_FAIL',

    GET_SYSTEM_FORMS: 'GET_SYSTEM_FORMS',
    GET_SYSTEM_FORMS_SUCCESS: 'GET_SYSTEM_FORMS_SUCCESS',
    GET_SYSTEM_FORMS_FAIL: 'GET_SYSTEM_FORMS_FAIL',

    SET_RECOMMENDATION: 'SET_RECOMMENDATION',

    SET_SYSTEM_FORM: 'SET_SYSTEM_FORM',

    TOGGLE_SUBSCRIPTION_MODAL: 'TOGGLE_SUBSCRIPTION_MODAL',

    TOGGLE_MESSAGE_MODAL: 'TOGGLE_MESSAGE_MODAL',
    /** This indicates if we should show the introductory modal */
    SET_SIGNUP_ROUTE: 'SET_SIGNUP_ROUTE',

    // Draft management actions
    SAVE_FORM_DRAFT: 'SAVE_FORM_DRAFT',
    LOAD_FORM_DRAFT: 'LOAD_FORM_DRAFT',
    CLEAR_FORM_DRAFT: 'CLEAR_FORM_DRAFT',
    CLEAR_ALL_DRAFTS: 'CLEAR_ALL_DRAFTS',
};

export type CreatorType = 'project' | 'contest' | 'playlist' | 'offsite_campaign' | undefined;
export interface IToggleCreator {
    creatorType: CreatorType;
    location?: CreatorLocation;
}

export interface IToastPayload {
    state: boolean;
    message: string;
}

export interface IChangeFilterSelection {
    category: string;
    subCategory: string;
    value: string;
}

export interface IToggleNotification {
    on: boolean;
}
export interface IToggleCookiesDrawer {
    on: boolean;
}
export interface IToggleAccountModal {
    on: boolean;
}

export interface ISetFilterPayload {
    category: FilterTypes;
    categoryPayload: DiscoveryFilter[];
}

export interface ISetFilterSubCategoryId {
    id: number | null;
}

export type SwitchStatus = 'on' | 'off';
export interface IFilterPayload {
    filterStatus: SwitchStatus;
    filterId?: number;
}

export type DrawerStatus = 'open' | 'closed';

export type FilterValueSet = {
    [id: number]: {
        value: string | boolean | number;
        displayName?: string;
        field?: string;
    };
};

export type FilterValueSetPayload = {
    id: number;
    value: string;
    displayName?: string;
    field?: string;
};
export interface ITutorialState {
    run: boolean;
    sidebarOpen?: boolean;
    stepIndex?: number;
    steps: Step[];
}
export type TGuide = {
    page: string;
    details: ITutorialState;
};

export interface IGuidePayload {
    page: string;
    run: boolean;
    steps: Step;
}

export interface IRecommendation {
    type: 'contest' | 'audition' | 'event' | 'role';
    document: IContest | IAudition | IEvent | IRole;
}

export interface IAppConfiguratorInitialState {
    currentPage: number;
    loading: boolean;
    drawerStatus: DrawerStatus;
    showSearchBox: TSwitch;
    selectedFilterCategory: FilterTypes;
    selectedFilterSubCatgory: DiscoveryFilter[];
    selectedFiltersValues: FilterValueSet;
    setFilters: any;
    filterStatus: SwitchStatus;
    filterSubCategoryId?: number | null;
    notificationOpen?: boolean;
    accountModalOpen?: boolean;
    creatorModal?: CreatorType;
    showToast?: boolean;
    toastMessage?: string;
    showGuide?: boolean;
    guide: TGuide[];
    selectedPageGuide?: TGuide;
    showProjectCreatorGuide?: boolean;
    showUserFirstProjectSuggestionBox?: boolean;
    cookiesDrawerOpen: boolean;
    shareModalStatus?: boolean;
    sharePayload?: {
        title: string;
        url: string;
    };
    currentRedirect?: string;
    showProjectGuide?: boolean;
    theme: 'dark' | 'light';
    selectedFilter?: IFilter;
    gettingFilter?: boolean;
    systemForms?: IRegistrationForm[];
    gettingForms?: boolean;
    formsError?: any;
    recommendation?: IRecommendation;
    currentSystemForm?: string;
    subscriptionModalOpen?: boolean;
    messageModalOpen?: boolean;
    signupRoute?: TSignUpRoutes;
    // Draft management state
    formDrafts?: { [formType: string]: any };
}

export type TSignUpRoutes = 'action-trigger' | 'direct' | 'none';

export type TSwitch = 'on' | 'off';

export enum FILTER_SWITCH {
    ON = 'on',
    OFF = 'off',
}

export interface ISetPage {
    pageIndex: number;
}

export interface ISetLoading {
    loading: boolean;
}

export interface IToggleDrawer {
    status: DrawerStatus;
}

export enum DRAWER_STATE {
    OPEN = 'open',
    CLOSED = 'closed',
}

export enum CREATOR_MODAL {
    PROJECT = 'project',
    CONTEST = 'contest',
}

export interface ISetGuide {
    showGuide: boolean;
    page?: string;
}

export interface IShareLinks {
    title?: string;
    url?: string;
    status: boolean;
}

export interface IGetFilter {
    coll_type: TCollType;
}

export interface IGetForms {
    tag: 'system' | 'unique';
}

export type TCollType = 'audition' | 'event' | 'user';

export type FilterType = 'dropdown' | 'checkbox' | 'radio' | 'range' | 'location' | 'date-range' | 'search';

export type TFilter = {
    name: string;
    type: FilterType;
    field_name: string[];
    default?: any;
    options?: string[];
    _id: string;
};

export interface IFilter {
    _id: string;
    coll_type: TCollType;
    filter: TFilter[];
    deleted: boolean;
    created_by: string;
    createdAt: string;
    updatedAt: string;
}

export type FormFieldType =
    | 'textInput'
    | 'dropdown'
    | 'pillSelection'
    | 'location'
    | 'calendar'
    | 'radioSelection'
    | 'phone'
    | 'slider'
    | 'range'
    | 'picture'
    | 'video'
    | 'suggestionTextInput'
    | 'currency';

interface IDepedency {
    depends_on: string;
    condition: {
        value: string;
        equality: '===' | '!==' | '==';
    };
}

export interface IRegistrationFormField {
    _id: string;
    field: string;
    form_type: FormFieldType;
    store_key: string;
    form_options: FormOption[];
    form_label?: string;
    form_name: string;
    form_header?: string;
    additional_store_keys?: string[];
    suggestion?: string[];
    position: number;
    deleted: boolean;
    __v: number;
    createdAt: string;
    updatedAt: string;
    id: string;
    calendarProps?: CalendarProps;
    suggestionTextInputProps?: ICustomizedMultipleInput;
    autoCompleteProps?: ICustomizedMultipleInput;
    textInputProps?: TextFieldProps;
    dependency?: IDepedency;
}

export interface CalendarProps {
    ageLimit?: number;
    maxDate?: number;
    minDate?: number;
}

export interface FormOption {
    label: string;
    value: string;
}

// Draft management interfaces
export interface ISaveFormDraft {
    formType: string;
    formData: any;
}

export interface ILoadFormDraft {
    formType: string;
}

export interface IClearFormDraft {
    formType: string;
}
